// extracted by mini-css-extract-plugin
module.exports = {"editBuildingButton":"BuildingSummary_editBuildingButton__ejb1d"};